<template>
  <div>
    <v-row no-gutters align="center" justify="start">
      <v-col style="max-width: 150px;" class="mr-2" cols="3">
        <ejercicio-picker
          v-model="filtros.ejercicio"
          sinPeriodo>
        </ejercicio-picker>
      </v-col>
      <v-col cols="3" style="max-width: 300px;" class="mr-2">
        <custom-select
          v-model="filtros.idEnteFiscalizador"
          label="Ente Fiscalizador"
          item-value="id"
          item-text="descripcion"
          clearable
          :items="getEntesFiscalizadores"
        >
        </custom-select>
      </v-col>
      <v-col cols="3" style="max-width: 300px;" class="mr-2">
        <custom-select
          v-model="filtros.idAuditoria"
          label="Auditoría"
          item-value="id"
          item-text="nombre"
          clearable
          :items="getAuditoriasPorEjercicio"
          :disabled="!filtros.idEnteFiscalizador"
        >
        </custom-select>
      </v-col>
      <v-col>
        <v-menu v-model="mostrar" :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-tune</v-icon>
            </v-btn>
          </template>
          <v-card width="300">
            <v-card-title>Filtros</v-card-title>
            <v-list>
              <v-list-item>
                <custom-select
                  v-model="filtros.idInforme"
                  label="Informe"
                  class="my-1"
                  :items="getInformesAuditorias"
                  item-text="nombre"
                  item-value="id"
                  clearable
                  :disabled="!filtros.idAuditoria"
                >
                </custom-select>
              </v-list-item>
              <v-list-item>
                <custom-select
                  v-model="filtros.etiquetas"
                  label="Etiquetas"
                  multiple
                  class="my-1"
                  :items="getEtiquetasAuditorias"
                  item-text="descripcion"
                  item-value="id"
                  clearable
                  chips
                  small-chips
                  deletable-chips
                >
                </custom-select>
              </v-list-item>
            </v-list>
            <v-card-text>
              <v-chip-group v-model="filtros.estatus" column mandatory>
                <v-chip :value="'sin-seguimiento'" filter outlined>Sin Seguimiento</v-chip>
                <v-chip :value="'con-seguimiento'" filter outlined>Con Seguimiento</v-chip>
                <v-chip :value="'archivados'" filter outlined>Archivados</v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ENTES_FISCALIZADORES from '@/graphql/querys/administracion/catalogos/entesfiscalizadores/entesFiscalizadores.gql';
import AUDITORIAS_POR_EJERICIO from '@/graphql/querys/administracion/auditorias/auditoriasPorEjercicio.gql';
import CATALOGO_AUDITORIA_ETIQUETAS from '@/graphql/querys/administracion/auditorias/catalogo-etiquetas/catalogoAuditoriaEtiquetas.gql';
import CustomSelect from '@/components/inputs/sinColumnas/Select.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';

export default {
  name: 'FiltrosSeguimientoAuditorias',
  components: {
    CustomSelect,
    EjercicioPicker,
  },
  props: {
    contratos: {
      type: Array,
      required: false,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  apollo: {
    entesFiscalizadores: {
      query: ENTES_FISCALIZADORES,
    },
    auditoriasPorEjercicio: {
      query: AUDITORIAS_POR_EJERICIO,
      variables() {
        return {
          ejercicio: this.filtros.ejercicio,
        };
      },
    },
    catalogoAuditoriaEtiquetas: {
      query: CATALOGO_AUDITORIA_ETIQUETAS,
    },
  },
  data() {
    return {
      mostrar: false,
    };
  },
  computed: {
    getEntesFiscalizadores() {
      if (!this.entesFiscalizadores || !this.auditoriasPorEjercicio) return [];
      const auditoriasEntes = this.auditoriasPorEjercicio
        .slice()
        .map((auditoria) => auditoria.idEnteFiscalizador);
      return this.entesFiscalizadores
        .filter((enteFiscalizador) => auditoriasEntes.includes(enteFiscalizador.id));
    },
    getAuditoriasPorEjercicio() {
      if (!this.auditoriasPorEjercicio) return [];
      return this.auditoriasPorEjercicio.filter(
        (auditoria) => auditoria.idEnteFiscalizador === this.filtros.idEnteFiscalizador,
      );
    },
    getEtiquetasAuditorias() {
      if (!this.catalogoAuditoriaEtiquetas) return [];
      return this.catalogoAuditoriaEtiquetas;
    },
    getInformesAuditorias() {
      if (!this.auditoriasPorEjercicio) return [];
      const informes = [];
      this.auditoriasPorEjercicio
        .filter((auditoria) => auditoria.id === this.filtros.idAuditoria)
        .forEach((auditoria) => {
          if (auditoria.informes && auditoria.informes.length > 0) {
            auditoria.informes.forEach((informe) => {
              if (!informes.some((inf) => inf.id === informe.id)) {
                informes.push({
                  id: informe.id,
                  nombre: informe.nombre,
                });
              }
            });
          }
        });
      return informes;
    },
  },
};
</script>

<style lang="scss"></style>
